require('gsap');
require('./plugins/MorphSVGPlugin');
require('./plugins/DrawSVGPlugin');

var ScrollMagic = require('ScrollMagic');
require('animation.gsap');
require('debug.addIndicators');

const ATTR_NAME = 'data-svganimate';

const BUSINESS_SVG = require('./svg/BUSINESS_SVG.svg');
const DESIGN_SVG = require('./svg/DESIGN_SVG.svg');
const TECHNOLOGY_SVG = require('./svg/TECHNOLOGY_SVG.svg');
const CLIENTS_SVG = require('./svg/CLIENTS_SVG.svg');


const _animateBusiness = (elWrapper) => {
  const smController = new ScrollMagic.Controller();
  const timeline = new TimelineMax();


  const scrollScene = new ScrollMagic.Scene({
    triggerElement: elWrapper.parentNode,
    reverse: false
  });

  // content
  const titleGreen = "#titleGreen";
  const subtitleGreen = "#subtitleGreen";
  const pGreen = "#pGreen";
  timeline.add([
    TweenMax.from(titleGreen, .5, {opacity: 0, y: 300, ease: Back.easeOut.config(1.5)}),
    TweenMax.from(subtitleGreen, .5, {opacity: 0, y: 200}).delay(.25),
    TweenMax.from(pGreen, .5, {opacity: 0, y: 200}).delay(.25)
  ]);

  //chairs sequence
  const chairs = elWrapper.getElementsByClassName('chair');
  timeline.add(
    TweenMax.staggerFrom(chairs, .5, {opacity: 0, y: -100}, 0.1)
  );

  //papers sequence
  const papersOnTable = elWrapper.getElementsByClassName('paper-on-desk');
  timeline.add(
    TweenMax.from(papersOnTable, .5, {opacity: 0, y: -100, ease: Bounce.easeOut})
  );

  //board sequence
  const board = elWrapper.getElementsByClassName('board');
  const boardPostIts = elWrapper.getElementsByClassName('board-post-it');
  timeline.add(
    TweenMax.from(board, .5, {opacity: 0, y: -50, x: -50, ease: Bounce.easeOut})
  );
  timeline.add(
    TweenMax.from(boardPostIts, .5, {opacity: 0, y: 20, x: 20, ease: Bounce.easeOut})
  )


  //animate on scrolling
  scrollScene.setTween(timeline).addTo(smController);

};

const _animateDesign = (elWrapper) => {

  const smController = new ScrollMagic.Controller();
  const timeline = new TimelineMax();

  const scrollScene = new ScrollMagic.Scene({
    triggerElement: elWrapper,
    reverse: false
  });

  // content
  const titleOrange = "#titleOrange";
  const subtitleOrange = "#subtitleOrange";
  const pOrange = "#pOrange";
  timeline.add([
    TweenMax.from(titleOrange, 1, {opacity: 0, y: 300, ease: Back.easeOut.config(1.5)}),
    TweenMax.from(subtitleOrange, 1, {opacity: 0, y: 200}).delay(.25),
    TweenMax.from(pOrange, 1, {opacity: 0, y: 200}).delay(.25)
  ]);

  const storymapping = elWrapper.getElementsByClassName('storymapping');
  const prototyping = elWrapper.getElementsByClassName('prototyping');
  const result = elWrapper.getElementsByClassName('result');
  const pen = elWrapper.getElementsByClassName('pen');

  timeline.add([
      TweenMax.from(storymapping, .5, {opacity: 0.5, y: -10, x: 10}),
      TweenMax.from(prototyping, .5, {opacity: 0, y: -50, x: 100}),
      TweenMax.from(result, .5, {opacity: 0, y: -50, x: 100})
    ]
  );

  //animate on scrolling
  scrollScene.setTween(timeline).addTo(smController);


};

const _animateTechnology = (elWrapper) => {

  const smController = new ScrollMagic.Controller();
  const timeline = new TimelineMax();

  const scrollScene = new ScrollMagic.Scene({
    triggerElement: elWrapper,
    reverse: false
  });

  // content
  const titleViolet = "#titleViolet";
  const subtitleViolet = "#subtitleViolet";
  const pViolet = "#pViolet";
  timeline.add([
    TweenMax.from(titleViolet, 1, {opacity: 0, y: 300, ease: Back.easeOut.config(1.5)}),
    TweenMax.from(subtitleViolet, 1, {opacity: 0, y: 200}).delay(.25),
    TweenMax.from(pViolet, 1, {opacity: 0, y: 200}).delay(.25)
  ]);

  const lines = ".lines";
  const lineTablet = "#lineTablet";
  const linePhone = "#linePhone";
  const lineLaptop = "#lineLaptop";

  const tablet = "#tablet";
  const phone = "#mobile";
  const laptop = "#laptop";

  const cloud = "#clowd";

  timeline.add([  // animate cloud
    TweenMax.from(cloud, 0.25, {opacity: .25, y: -25})
  ]);
  timeline.add([
    // animate lines
    TweenMax.set(lines, {opacity: 0}).reverse(),
    TweenMax.fromTo(lineTablet, 1, {drawSVG: "28% 28%"}, {drawSVG: "0% 100%"}),
    TweenMax.fromTo(linePhone, 1, {drawSVG: "23% 23%"}, {drawSVG: "0% 100%"}),
    TweenMax.fromTo(lineLaptop, 1, {drawSVG: "70% 70%"}, {drawSVG: "0% 100%"}),
    // animate objects
    TweenMax.from(tablet, 1, {opacity: 0, x: -100, ease: Back.easeOut.config(3)}),
    TweenMax.from(phone, 1, {opacity: 0, y: 100, ease: Back.easeOut.config(3)}),
    TweenMax.from(laptop, 1, {opacity: 0, x: 100, ease: Back.easeOut.config(3)})
  ]);

  scrollScene.setTween(timeline).addTo(smController);

};

const _animate = (elWrapper, svgRef) => {
  switch (svgRef) {
    case 'BUSINESS_SVG':
      _animateBusiness(elWrapper);
      break;
    case 'DESIGN_SVG':
      _animateDesign(elWrapper);
      break;
    case 'TECHNOLOGY_SVG':
      _animateTechnology(elWrapper);
      break;
    default:
      svgSrc = null;

  }

};

const _load = (elWrapper, svgRef, cb) => {
  let svgSrc = null;
  switch (svgRef) {
    case 'BUSINESS_SVG':
      svgSrc = BUSINESS_SVG;
      break;
    case 'DESIGN_SVG':
      svgSrc = DESIGN_SVG;
      break;
    case 'TECHNOLOGY_SVG':
      svgSrc = TECHNOLOGY_SVG;
      break;
    default:
      svgSrc = null;

  }

  if (svgSrc) {
    const ajax = new XMLHttpRequest();
    ajax.open("GET", svgSrc, true);
    ajax.send();
    ajax.onload = function (e) {
      elWrapper.innerHTML = ajax.responseText;
      cb(elWrapper);


    }
  }

  else {
    console.warn('SVG ' + svgRef + ' not available');
  }

};


const initializeSVGBusinessDesignTechnology = () => {

  const svgAnimateElements = document.querySelectorAll('[' + ATTR_NAME + ']');

  _load(svgAnimateElements[0], svgAnimateElements[0].getAttribute(ATTR_NAME), function (elWrapper) {
    _animateBusiness(elWrapper);

    _load(svgAnimateElements[1], svgAnimateElements[1].getAttribute(ATTR_NAME), function (elWrapper) {
      _animateDesign(elWrapper);

      _load(svgAnimateElements[2], svgAnimateElements[2].getAttribute(ATTR_NAME), function (elWrapper) {
        _animateTechnology(elWrapper);

      });
    });
  });


  const moreLinks = document.getElementsByClassName('bdt__more-link');

  for (let i = 0; i < moreLinks.length; i++) {
    let link = moreLinks[i];
    let linkSpan = link.querySelector('span');
    let moreContent = link.parentNode.querySelector('.bdt__item__more');
    moreLinks[i].addEventListener('mouseover', () => {
      TweenMax.to(moreContent, 1, {y: '-100%', ease: Bounce.easeOut});
      moreContent.classList.add('active');
    });
    moreLinks[i].addEventListener('mouseout', () => {
      moreContent.classList.remove('active');
      TweenMax.to(moreContent, 1, {y: '0%', ease: Bounce.easeOut});
    });
  }


  // for (let i = 0; i < svgAnimateElements.length; i++) {
  //   _load(svgAnimateElements[i], svgAnimateElements[i].getAttribute(ATTR_NAME));
  // }


};


export default initializeSVGBusinessDesignTechnology;



/** WEBPACK FOOTER **
 ** ./src/script/svganimations/business-design-technology.js
 **/